var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"in-review-snapshot-table"},[_c('v-client-table',{staticClass:"items-grid",attrs:{"columns":_vm.columns,"data":_vm.tableData,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }